<template>
    <div :style="'font-size:' +fontSize+ 'px'" class="phoneEmpower-container">
        <div class="step-container">
            <p :class="{on: true}"><i>1</i><span>绑定账号</span></p>
            <p :class="{on: type == 'empty' || type == 'error' || type == 'selectList' || type == 'success'}"><i>2</i><span>绑定系统</span></p>
            <p :class="{on: type == 'success'}"><i>3</i><span>绑定成功</span></p>
        </div>

        <div :class="{'box-container': true, empty: type == 'empty', error: type == 'error', selectList: type == 'selectList', success: type == 'success'}">
            <div class="logo-container">
                <div class="logo"></div>
                <div class="title"></div>
            </div>

            <div v-show="type == 'account' || type == 'phone'" class="tab-container">
                <p @click="type = 'account'" :class="{on: type == 'account'}">账号绑定</p>
                <!-- <p @click="type = 'phone'" :class="{on: type == 'phone'}">验证码绑定</p> -->
            </div>

            <div v-show="type == 'account'" class="input">
                <input @focus="accountClick = true" @blur="accountClick = false" v-model="account" placeholder="请输入Xnews、@radio等台内账号" type="text">
                <div @click="account = ''" v-show="account.length > 0 && accountClick" class="del"></div>
            </div>

            <div v-show="type == 'account'" class="input">
                <input @focus="pwdClick = true" @blur="pwdClick = false" v-model="pwd" placeholder="请输入Xnews、@radio等台内密码" type="password">
                <div @click="pwd = ''" v-show="pwd.length > 0 && pwdClick" class="del"></div>
            </div>

            <div v-show="type == 'phone'" class="input">
                <input @focus="phoneClick = true" @blur="phoneClick = false" v-model="phone" placeholder="请输入手机号" type="text">
                <div @click="phone = ''" v-show="phone.length > 0 && phoneClick" class="del"></div>
            </div>

            <div v-show="type == 'phone'" class="short">
                <input v-model="code" placeholder="请输入短信验证码" type="text">
                <div class="shortBtn"><p>发送验证码</p></div>
            </div>

            <div @click="login" v-show="type == 'account' || type == 'phone'" class="btn"><p>下一步</p></div>
        
            <div v-show="type == 'loading'" class="load-container">
                <div class="load"></div>
                <div class="text">正在校验账号…</div>
            </div>

            <div v-show="type == 'empty'" class="empty-container">
                <div class="empty">
                    <div class="logo"></div>
                    <div class="text">暂无绑定系统，请联系管理员</div>
                </div>
                <div @click="type = 'account'" class="rebind"><p>重新绑定</p></div>
            </div>

            <div v-show="type == 'error'" class="error-container">
                <div class="error">
                    <div class="logo"></div>
                    <div class="title">绑定失败！</div>
                    <div class="text">失败原因：当前网络正忙，请稍后再尝试。</div>
                </div>
                <div @click="type = 'account'" class="rebind"><p>重新绑定</p></div>
            </div>

            <div v-show="type == 'selectList'" class="list-container">
                <div class="notice">请选择一个系统身份登录剪映<span>（仅可选择一个）</span>以下系统可在剪映中切换身份使用</div>
                <div class="list">
                    <ul>
                        <li @click="selectIndex = index" v-for="(item, index) in systemList" :key="index">
                            <div :class="{cover: true, on: selectIndex == index}">
                                <div style="background-image: url('../assets/img/empower/knews.png')" class="logo"></div>
                            </div>  
                            <div class="title">Xnews</div>
                        </li>
                    </ul>
                </div>
                <div @click="submit" class="next"><p>下一步</p></div>
            </div>

            <div v-show="type == 'success'" class="success-container">
                <div class="successLogo">
                    <div class="logo"></div>
                    <div class="text">绑定成功！</div>
                </div>
                <div class="bind"><p>完成绑定</p></div>
            </div>
        </div>

        <div class="copyright">SMT RDC 提供技术支持</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fontSize: 100,
            type: 'account',
            account: '',
            pwd: '',
            code: '',
            phone: '',
            accountClick: false,
            pwdClick: false,
            phoneClick: false,
            systemList: [1,2,3,4,5,6,7,8,9,0],
            selectIndex: 9999
        }
    },
    methods: {
        login() {
            let info = {
                account: this.account,
                password: this.password
            }

            this.type = 'selectList'
        },
        submit() {
            if(this.selectIndex == 9999){
                this.$toast('请选择一个系统身份')
            }else{
                this.type = 'success'
            }
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 375);

            this.fontSize = p
        }
    },
    mounted() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()
    }
}
</script>

<style lang="less" scoped>
    .phoneEmpower-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        background: url('../assets/img/empower/bg.png') no-repeat;
        background-position: center center;
        background-size: cover;

        .step-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 1.8em;
            margin-bottom: 0.7em;

            p {
                display: flex;
                align-items: center;
                font-size: 0.13em;
                color: #FFFFFF;
                font-weight: bold;

                &.on {

                    i {
                        background: #FFFFFF;
                        border: 0.077em solid #FFFFFF;
                        color: #556FFF;
                        opacity: 1;
                    }

                    span {
                        opacity: 1;
                    }
                }

                i {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 1.23em;
                    height: 1.23em;
                    border-radius: 50%;
                    border: 0.077em solid #FFFFFF;
                    box-sizing: border-box;
                    font-size: 0.923em;
                    margin: 0 0.615em 0 0;
                    padding-bottom: 1px;
                    opacity: 0.6;
                }

                span {
                    opacity: 0.6;
                }

                &:nth-of-type(2) {
                    &::before {
                        display: block;
                        content: '';
                        width: 1.538em;
                        height: 0.077em;
                        background: rgba(255,255,255,0.2);
                        margin: 0 0.769em;
                    }

                    &::after {
                        display: block;
                        content: '';
                        width: 1.538em;
                        height: 0.077em;
                        background: rgba(255,255,255,0.2);
                        margin: 0 0.769em;
                    }
                }
            }
        }

        .box-container {
            position: relative;
            width: 3.15em;
            height: 3.04em;
            background: #FFFFFF;
            box-shadow: 0.02em 0.02em 0.05em 0px rgba(5,10,15,0.05);
            border-radius: 0.1em;
            margin: 0 auto;
            padding: 0.5em 0.22em 0.35em;
            box-sizing: border-box;

            &.empty {
                height: 4.38em;
                padding: 0.87em 0.22em 0.3em;
                box-sizing: border-box;

                .empty-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;

                    .empty {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .logo {
                            display: block;
                            width: 1.79em;
                            height: 1.88em;
                            background: url('../assets/img/empower/empty.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-bottom: 0.2em;
                        }

                        .text {
                            font-size: 0.13em;
                            color: #050F0F;
                        }
                    }

                    .rebind {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 2.7em;
                        height: 0.44em;
                        background: #2269FF;
                        border-radius: 0.06em;

                        p {
                            font-size: 0.17em;
                            color: #FFFFFF;
                            font-weight: bold;
                        }
                    }
                }
            }

            &.error {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                height: 4.38em;
                padding: 0.74em 0.22em 0.3em;
                box-sizing: border-box;

                .error {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .logo {
                        width: 1.95em;
                        height: 1.98em;
                        background: url('../assets/img/empower/error.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        margin-bottom: 0.18em;
                    }

                    .title {
                        font-size: 0.17em;
                        line-height: 1.412em;
                        color: #050F0F;
                        margin-bottom: 0.353em;
                    }

                    .text {
                        font-size: 0.13em;
                        line-height: 1.423em;
                        color: #050F0F;
                    }
                }

                .rebind {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 2.7em;
                    height: 0.44em;
                    background: #2269FF;
                    border-radius: 0.06em;
                    margin-top: 0.28em;

                    p {
                        font-size: 0.17em;
                        color: #FFFFFF;
                        font-weight: bold;
                    }
                }
            }

            &.selectList {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                height: 4.38em;
                padding: 0.49em 0.19em 0.3em;
                box-sizing: border-box;

                .list-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;

                    .notice {
                        font-size: 0.13em;
                        line-height: 1.538em;
                        color: #829191;
                        margin-bottom: 1.538em;

                        span {
                            color: #2269FF;
                        }
                    }

                    .list {
                        width: 100%;
                        flex: 1;
                        min-height: 0;

                        ul {
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%;
                            height: 100%;
                            overflow-y: auto;

                            li {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                margin-bottom: 0.15em;
                                margin-right: 0.075em;

                                &:nth-of-type(3n) {
                                    margin-right: 0;
                                }

                                .cover {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 0.84em;
                                    height: 0.84em;
                                    background: #F3F4F6;
                                    border-radius: 0.12em;
                                    margin-bottom: 0.05em;
                                    border: 1px solid #F3F4F6;
                                    box-sizing: border-box;

                                    .logo {
                                        display: block;
                                        width: 0.65em;
                                        height: 0.36em;
                                        // background-image: url('../assets/img/empower/knews.png');
                                        background-repeat: no-repeat;
                                        background-size: contain;
                                        background-position: center center;
                                    }

                                    &.on {
                                        background: #FFF;
                                        border: 1px solid #2269FF;
                                        box-sizing: border-box;
                                    }
                                }

                                .title {
                                    font-size: 0.13em;
                                    line-height: 1.423em;
                                    color: #323B4B;
                                }
                            }
                        }
                    }

                    .next {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 2.7em;
                        height: 0.44em;
                        background: #2269FF;
                        border-radius: 0.06em;
                        margin-top: 0.2em;

                        p {
                            font-size: 0.17em;
                            color: #FFF;
                            font-weight: bold;
                        }
                    }
                }
            }

            &.success {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                height: 4.38em;
                padding: 0.7em 0.22em 0.3em;
                box-sizing: border-box;

                .success-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    height: 100%;

                    .successLogo {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .logo {
                            width: 2.4em;
                            height: 2.02em;
                            background: url('../assets/img/empower/success.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-bottom: 0.18em;
                        }

                        .text {
                            font-size: 0.17em;
                            line-height: 1.412em;
                            color: #050F0F;
                        }
                    }

                    .bind {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 2.7em;
                        height: 0.44em;
                        background: #2269FF;
                        border-radius: 0.06em;

                        p {
                            font-size: 0.17em;
                            color: #FFF;
                            font-weight: bold;
                        }
                    }
                }
            }

            .logo-container {
                position: absolute;
                left: 50%;
                top: -0.31em;
                transform: translate(-50%,0);
                display: flex;
                align-items: center;
                justify-content: center;
                width: 2.4em;
                height: 0.6em;
                background: #FFFFFF;
                box-shadow: 0px 0.1em 0.12em 0px rgba(153,155,168,0.18);
                border-radius: 0.3em;

                .logo {
                    display: block;
                    width: 0.38em;
                    height: 0.38em;
                    background: url('../assets/img/empower/logo.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 0.1em;
                }

                .title {
                    display: block;
                    width: 1.32em;
                    height: 0.16em;
                    background: url('../assets/img/empower/title_save.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                }
            }

            .tab-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;
                padding-bottom: 0.1em;
                border-bottom: 1px solid #E6E6E6;
                box-sizing: border-box;

                p {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 50%;
                    font-size: 0.15em;
                    font-weight: bold;
                    color: #B4B4B4;
                    line-height: 1.4em;

                    &.on {
                        position: relative;
                        color: #2269FF;

                        &::after {
                            position: absolute;
                            left: 0;
                            bottom: -0.68em;
                            display: block;
                            content: '';
                            width: 100%;
                            height: 1px;
                            background: #2269FF;
                            z-index: 9;
                        }
                    }
                }
            }

            .input {
                display: flex;
                align-items: center;
                width: 100%;
                height: 0.39em;
                background: rgba(185,195,195,0.15);
                margin-top: 0.15em;
                padding: 0 0.1em 0 0.15em;
                box-sizing: border-box;

                input {
                    flex: 1;
                    min-width: 0;
                    height: 100%;
                    background: transparent;
                }

                .del {
                    display: block;
                    width: 0.2em;
                    height: 0.2em;
                    background: url('../assets/img/empower/del.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    user-select: none;
                    cursor: pointer;
                }
            }

            .short {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin-top: 0.15em;

                input {
                    width: 12.143em;
                    height: 2.786em;
                    background: rgba(185,195,195,0.15);
                    font-size: 0.14em;
                    padding: 0 1.071em;
                    box-sizing: border-box;
                }   

                .shortBtn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 6.923em;
                    height: 3em;
                    background: #2269FF;
                    border-radius: 0.308em;
                    font-size: 0.13em;
                    color: #FFF;
                }
            }

            .btn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 2.7em;
                height: 0.44em;
                background: #2269FF;
                border-radius: 0.06em;
                margin-top: 0.35em;
                cursor: pointer;
                user-select: none;

                p {
                    font-size: 0.17em;
                    color: #FFFFFF;
                    font-weight: bold;
                }
            }

            .load-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 0.8em;

                .load {
                    width: 0.5em;
                    height: 0.5em;
                    background: url('../assets/img/empower/load.gif') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-bottom: 0.14em;
                }

                .text {
                    font-size: 0.13em;
                    line-height: 1.385em;
                    color: #050F0F;
                }
            }
        }

        .copyright {
            position: fixed;
            bottom: 1.818em;
            left: 50%;
            transform: translate(-50%, 0);
            font-size: 0.11em;
            line-height: 1.364em;
            color: #B0B7C1;
        }
    }
</style>